import { Backend, getQueryParamValue } from '@shared/datastore/core';
import { HourlyContractsGetResultApi } from 'api-typings/payments/payments';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    hourlyContracts: HourlyContractsGetResultApi;
  }
}

export const hourlyContractsBackend: Backend<'hourlyContracts'> = {
  fetch: (_, ids, query) => ({
    endpoint: `projects/0.1/hourly_contracts`,
    params: {
      project_ids: query ? getQueryParamValue(query, 'projectId') : [],
    },
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/hourly-contracts/hourly-contracts.backend.ts